import styled from 'styled-components'

export const SelectedLanguageDisplay = styled.div`
  display: flex;
  justify-content: center;
  color: ${({ theme }) => theme.colour};
  font-weight: 600;
  font-style: SemiBold;
  font-size: 16px;
  line-height: 100%;
  letter-spacing: 0px;
  text-align: center;
  vertical-align: middle;
  align-items: center;
  gap: 10px;
  margin: 20px 70px;
  padding: 30px;
  cursor: pointer;
`

export const LanguageListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const LanguageListItem = styled.div`
  background: ${({ theme }) => theme.ItemsBackGround};
  color: ${({ theme }) => theme.FontColor};
  border: ${({ theme }) => `1px solid ${theme.ItemsBorders}`};
  width: 100%;
  height: 50px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 10px;
  padding: 0 15px;
  cursor: pointer;
`
